import { isEmpty } from 'lodash-es';
import { createContext, useState, useContext, PropsWithChildren, useEffect } from 'react';
import { getSubmissionSettings } from 'wisestep-api';
import { ISubmissionSettingContext } from 'wisestep-base';

export const SubmissionSettingContext = createContext<ISubmissionSettingContext | null>(null);

export default function SubmissionSettingContextProvider(
  props: PropsWithChildren<ISubmissionSettingContext | null>
) {
  const [settings, setSettings] = useState<ISubmissionSettingContext | null>(null);

  useEffect(() => {
    (async function () {
      if (isEmpty(settings)) {
        const res = await getSubmissionSettings();
        setSettings(res.data);
      }
    })();
  }, [settings]);

  return (
    <>
      {settings != null && (
        <SubmissionSettingContext.Provider value={{ ...settings }}>
          {props.children}
        </SubmissionSettingContext.Provider>
      )}
    </>
  );
}

export function useSubmissionSettingContext() {
  const context = useContext(SubmissionSettingContext);
  if (!context) {
    throw new Error('useAppState must be used within the AuthContextProvider');
  }
  return context;
}
